import { SeriesWarningEnum } from '../../../store/series/types';
import { CardWarning } from '../types';

// Priority: outcome missing > follow-up missing > ratio exceeded.
// Matches the prototype's getWarnColor (ha-series-redesign.html L393-398) which
// renders the warning label that "wins" — multiple warnings can be present on
// the same series but the card shows one at a time.
export function resolveCardWarning(warnings: SeriesWarningEnum[]): CardWarning | null {
  if (warnings.includes(SeriesWarningEnum.FOLLOWUP_MISSING)) {
    return 'followupMissing';
  }
  if (warnings.includes(SeriesWarningEnum.RATIO_EXCEEDED)) {
    return 'ratioExceeded';
  }
  if (warnings.includes(SeriesWarningEnum.OUTCOME_MISSING)) {
    return 'outcomeMissing';
  }
  return null;
}
